<script src="../../../store/module/vehicleinfoserv.js"></script>
<template>
  <Modal
    v-model="_value"
    width="900"
    title="添加车辆信息"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Tabs type="card">
      <TabPane label="车辆必要信息">
        <Form ref="loginForm" :model="vehicleInfo" :rules="rules">
          <Row>
            <Col span="8">
              <FormItem prop="registrationNum">
                <label>车牌号码</label>
                <Input class="field" v-model="vehicleInfo.registrationNum" placeholder="请输入车牌号码">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="name">
                <label>车牌颜色</label>
                <Select class="field" v-model="vehicleInfo.registrationColor">
                  <Option v-for="item in registrationColorOptions" :value="item.value" :key="item.value">
                    {{item.label}}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vin">
                <label>车架号</label>
                <Input class="field" v-model="vehicleInfo.vin" placeholder="请输入车架号">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="engineBrandName">
                <label>发动机品牌</label>
                <Select
                    placeholder="请输入发动机品牌名称"
                    v-model="vehicleInfo.engineBrand.name"
                    filterable
                    remote
                    :remote-method="searchEngineBrand"
                    :loading="searchEngineBrandLoading"
                    class="field"
                    clearable>
                  <Option v-for="(option, index) in searchEngineBrandList" :value="option.name" :key="option.name">{{option.name}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleTypeName">
                <label>车辆类型</label>
                <Select
                  placeholder="请输入车辆类型名称"
                  v-model="vehicleInfo.vehicleType.name"
                  filterable
                  remote
                  :remote-method="searchVehicleType"
                  :loading="searchVehicleTypeLoading"
                  class="field"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleTypeList" :value="option.name" :key="option.name">{{option.name}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleBrandName">
                <label>车辆品牌</label>
                <Select
                  placeholder="请输入车辆品牌名称"
                  v-model="vehicleInfo.vehicleBrand.name"
                  filterable
                  remote
                  :remote-method="searchVehicleBrand"
                  :loading="searchVehicleBrandLoading"
                  class="field"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleBrandList" :value="option.name" :key="option.name">{{option.name}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="bodyColor">
                <label>车身颜色</label>
                <Input class="field" v-model="vehicleInfo.bodyColor" placeholder="请输入车身颜色">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="engineNum">
                <label>发动机号</label>
                <Input class="field" v-model="vehicleInfo.engineNum" placeholder="请输入发动机号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleLicenseNum">
                <label>行驶证号</label>
                <Input class="field" v-model="vehicleInfo.vehicleLicenseNum" placeholder="请输入行驶证号">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="unladenMass">
                <label>整备质量(kg)</label>
                <InputNumber class="field" :min="0" v-model="vehicleInfo.unladenMass"
                             placeholder="请输入整备质量"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="engineNum">
                <label>核准载重(kg)</label>
                <InputNumber class="field" :min="0" v-model="vehicleInfo.approvedLoad"
                             placeholder="请输入核准载重"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleUse">
                <label>使用性质</label>
                <Input class="field" v-model="vehicleInfo.vehicleUse" placeholder="请输入使用性质">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="totalPrice">
                <label>售价(万)</label>
                <InputNumber class="field" v-model="vehicleInfo.totalPrice" placeholder="售价">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="driverGearCount">
                <label>前进档位数</label>
                <InputNumber class="field" v-model="vehicleInfo.driverGearCount" placeholder="前进档位数">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="mileage">
                <label>行驶里程</label>
                <InputNumber class="field" v-model="vehicleInfo.mileage" placeholder="行驶里程">
                </InputNumber>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="canFiling">
                <label>是否可提档</label>
                <Select class="field" v-model="vehicleInfo.canFiling">
                  <Option value="1" key="1">是</Option>
                  <Option value="0" key="0">否</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="canTransfer">
                <label>是否可过户</label>
                <Select class="field" v-model="vehicleInfo.canTransfer">
                  <Option value="1" key="1">是</Option>
                  <Option value="0" key="0">否</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem prop="vehicleOwnerInfoId">
                <label>车辆所有人信息</label>
                <Select
                  placeholder="请选择车辆所有人名称"
                  v-model="vehicleInfo.vehicleOwnerInfoId"
                  filterable
                  remote
                  :remote-method="searchVehicleOwnerInfo"
                  :loading="searchVehicleOwnerInfoLoading"
                  class="field" style="width: 80%;"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleOwnerInfoList" :value="option.name" :key="option.id">{{option.name}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem prop="remark">
                <label>备注</label>
                <Input class="field" style="width: 80%;" v-model="vehicleInfo.remark" type="textarea"
                       placeholder="请输入备注">
                </Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </TabPane>
      <TabPane label="车辆基本信息1">
        <Form ref="loginForm" :model="vehicleInfo" :rules="rules">
          <Row>
            <Col span="8">
              <FormItem prop="servicePassword">
                <label>服务密码</label>
                <Input class="field" v-model="vehicleInfo.servicePassword" placeholder="请输入服务密码">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleLicenseDistributeDatetime">
                <label>行驶证发证日期</label>
                <DatePicker type="date" v-model="vehicleInfo.vehicleLicenseDistributeDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleLicenseReigsterDatetime">
                <label>行驶证注册日期</label>
                <DatePicker type="date" v-model="vehicleInfo.vehicleLicenseReigsterDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="certificateNum">
                <label>合格证编号</label>
                <Input class="field" v-model="vehicleInfo.certificateNum" placeholder="请输入合格证编号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="certificateDistributeDatetime">
                <label>合格证发证日期</label>
                <DatePicker class="field" style="width: 60%;" type="date"
                            v-model="vehicleInfo.certificateDistributeDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vehicleModelName">
                <label>车辆型号</label>
                <Select
                  placeholder="请输入车辆型号名称"
                  v-model="vehicleInfo.vehicleModel.name"
                  filterable
                  remote
                  :remote-method="searchVehicleModel"
                  :loading="searchVehicleModelLoading"
                  class="field"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleModelList" :value="option.name" :key="option.name">{{option.name}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="chassisModel">
                <label>底盘型号</label>
                <Input class="field" v-model="vehicleInfo.chassisModel" placeholder="请输入底盘型号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="chassisId">
                <label>底盘ID</label>
                <Input class="field" v-model="vehicleInfo.chassisId" placeholder="请输入底盘ID">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="chassisCertificateNum">
                <label>底盘合格证编号</label>
                <Input class="field" style="width: 60%;" v-model="vehicleInfo.chassisCertificateNum"
                       placeholder="请输入底盘合格证编号">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="engineModel">
                <label>发动机型号</label>
                <Input class="field" v-model="vehicleInfo.engineModel" placeholder="请输入发动机型号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="energyType">
                <label>发动机类型</label>
                <Input class="field" v-model="vehicleInfo.energyType" placeholder="请输入发动机类型">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="displacement">
                <label>能耗</label>
                <Input class="field" v-model="vehicleInfo.displacement" placeholder="请输入能耗">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="engineModel">
                <label>发动机型号</label>
                <Input class="field" v-model="vehicleInfo.engineModel" placeholder="请输入发动机型号">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="energyType">
                <label>发动机类型</label>
                <Input class="field" v-model="vehicleInfo.energyType" placeholder="请输入发动机类型">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="displacement">
                <label>排量(ml)</label>
                <Input class="field" v-model="vehicleInfo.displacement" placeholder="请输入排量">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="power">
                <label>功率(kW)</label>
                <Input class="field" v-model="vehicleInfo.power" placeholder="请输入功率">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="energyUsage">
                <label>能耗</label>
                <Input class="field" v-model="vehicleInfo.energyUsage" placeholder="请输入能耗">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="emissionStandard">
                <label>排放标准</label>
                <Input class="field" v-model="vehicleInfo.emissionStandard" placeholder="请输入排放标准">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="manufacturer">
                <label>制造商名称</label>
                <Input class="field" v-model="vehicleInfo.manufacturer" placeholder="请输入制造商名称">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="springPieceCount">
                <label>钢板弹簧片数</label>
                <Input class="field" v-model="vehicleInfo.springPieceCount" placeholder="请输入钢板弹簧片数">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="turnType">
                <label>转向形式</label>
                <Input class="field" v-model="vehicleInfo.turnType" placeholder="请输入转向形式">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="outlineSizeLong">
                <label>外廓尺寸长(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="vehicleInfo.outlineSizeLong"
                             placeholder="请输入外廓尺寸长"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="outlineSizeWidth">
                <label>外廓尺寸宽(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="vehicleInfo.outlineSizeWidth"
                             placeholder="请输入外廓尺寸宽"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="outlineSizeHeight">
                <label>外廓尺寸高(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="vehicleInfo.outlineSizeHeight"
                             placeholder="请输入外廓尺寸高"></InputNumber>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="boxSizeLong">
                <label>货厢内部尺寸长(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="vehicleInfo.boxSizeLong"
                             placeholder="请输入货厢内部尺寸长"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="boxSizeWidth">
                <label>货厢内部尺寸宽(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="vehicleInfo.boxSizeWidth"
                             placeholder="请输入货厢内部尺寸宽"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="boxSizeHeight">
                <label>货厢内部尺寸高(mm)</label>
                <InputNumber class="field" style="width: 60%;" :min="0" v-model="vehicleInfo.boxSizeHeight"
                             placeholder="请输入货厢内部尺寸高"></InputNumber>
              </FormItem>
            </Col>
          </Row>

        </Form>
      </TabPane>
      <TabPane label="车辆基本信息2">
        <Form ref="loginForm" :model="vehicleInfo" :rules="rules">
          <Row>
            <Col span="8">
              <FormItem prop="tyreCount">
                <label>轮胎数量</label>
                <Input class="field" v-model="vehicleInfo.tyreCount" placeholder="请输入轮胎数量">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="tyreSpec">
                <label>轮胎规格</label>
                <Input class="field" v-model="vehicleInfo.tyreSpec" placeholder="请输入轮胎规格">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="wheelSpanFront">
                <label>前轮距</label>
                <Input class="field" v-model="vehicleInfo.wheelSpanFront" placeholder="请输入前轮距">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="wheelSpanBack">
                <label>后轮距</label>
                <Input class="field" v-model="vehicleInfo.wheelSpanBack" placeholder="请输入后轮距">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="wheelBase">
                <label>轴距</label>
                <Input class="field" v-model="vehicleInfo.wheelBase" placeholder="请输入轴距">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="axisLoad">
                <label>轴荷(kg)</label>
                <Input class="field" v-model="vehicleInfo.axisLoad" placeholder="请输入轴荷">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="axisCount">
                <label>轴数</label>
                <Input class="field" v-model="vehicleInfo.axisCount" placeholder="请输入轴数">
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="totalMass">
                <label>总质量(kg)</label>
                <InputNumber :min="0" class="field" v-model="vehicleInfo.totalMass" placeholder="请输入总质量">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="approvedLoadCoefficient">
                <label>载质量利用系数</label>
                <Input class="field" style="width: 50%;" v-model="vehicleInfo.approvedLoadCoefficient"
                       placeholder="请输入载质量利用系数">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="wheelCount">
                <label>总轮数</label>
                <InputNumber :min="0" step="1" class="field" v-model="vehicleInfo.wheelCount" placeholder="请输入总轮数">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="driveWheelCount">
                <label>总驱动轮数</label>
                <InputNumber :min="0" step="1" class="field" v-model="vehicleInfo.driveWheelCount" placeholder="请输入总驱动轮数">
                </InputNumber>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="towMax">
                <label>准牵引总质量(kg)</label>
                <InputNumber :min="0" style="width: 30%;" class="field" v-model="vehicleInfo.towMax"
                             placeholder="请输入准牵引总质量">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="saddleMax">
                <label>半挂车鞍座最大允许总质量(kg)</label>
                <InputNumber :min="0" class="field" style="width: 30%;" v-model="vehicleInfo.saddleMax"
                             placeholder="请输入半挂车鞍座最大允许总质量">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="cabPeopleCount">
                <label>驾驶室准乘人数(人)</label>
                <InputNumber :min="0" class="field" style="width: 50%;" v-model="vehicleInfo.cabPeopleCount"
                             placeholder="请输入驾驶室准乘人数">
                </InputNumber>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="mannedCount">
                <label>额定载客(人)</label>
                <InputNumber :min="0" class="field" v-model="vehicleInfo.mannedCount" placeholder="请输入额定载客">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="speedMax">
                <label>最高设计车速(km/h)</label>
                <InputNumber :min="0" style="width: 40%;" class="field" v-model="vehicleInfo.speedMax"
                             placeholder="请输入最高设计车速">
                </InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="productionDatetime">
                <label>车辆制造日期</label>
                <DatePicker type="date" v-model="vehicleInfo.productionDatetime"
                            placeholder="选择日期"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem prop="certificateRemark">
                <label>合格证备注</label>
                <Input class="field" style="width: 80%;" v-model="vehicleInfo.certificateRemark" type="textarea"
                       placeholder="请输入合格证备注">
                </Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </TabPane>
    </Tabs>
    <Row style="text-align: right;">
      <i-switch v-model="vehicleInfo.test" size="large">
        <span slot="open">正常</span>
        <span slot="close">测试</span>
      </i-switch>
    </Row>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'AddVehicleInfoModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    nameRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车辆名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      searchVehicleModelLoading: false,
      searchVehicleModelList: [],
      searchClientInfoLoading: false,
      searchClientInfoList: [],
      searchVehicleOwnerInfoLoading: false,
      searchVehicleOwnerInfoList: [],
      searchVehicleTypeLoading: false,
      searchVehicleTypeList: [],
      searchVehicleBrandLoading: false,
      searchVehicleBrandList: [],
      searchEngineBrandLoading: false,
      searchEngineBrandList: [],

      registrationColorOptions: [
        { label: '蓝色', value: 1 },
        { label: '黄色', value: 2 },
        { label: '黑色', value: 3 },
        { label: '白色', value: 4 }
      ],
      vehicleInfo: {
        customName: null,
        registrationNum: null,
        registrationColor: null,
        vin: null,
        bodyColor: null,
        vehicleType: {
          name: null
        },
        vehicleBrand: {
          name: null
        },
        engineBrand: {
          name: null
        },
        engineNum: null,
        vehicleLicenseNum: null,
        unladenMass: null,
        approvedLoad: null,
        vehicleOwnerInfoId: null,
        clientInfoId: null,
        servicePassword: null,
        vehicleLicenseDistributeDatetime: null,
        vehicleLicenseReigsterDatetime: null,
        businessUserId: null, /// //
        remark: null,
        certificateNum: null,
        certificateDistributeDatetime: null,
        vehicleModel: {
          name: null
        },
        chassisModel: null,
        chassisId: null,
        chassisCertificateNum: null,
        engineModel: null,
        energyType: null,
        displacement: null,
        power: null,
        energyUsage: null,
        emissionStandard: null,
        manufacturer: null,
        outlineSizeLong: null,
        outlineSizeWidth: null,
        outlineSizeHeight: null,
        boxSizeLong: null,
        boxSizeWidth: null,
        boxSizeHeight: null,
        springPieceCount: null,
        tyreCount: null,
        tyreSpec: null,
        wheelSpanFront: null,
        wheelSpanBack: null,
        wheelBase: null,
        wheelCount:null,
        driveWheelCount:null,
        axisLoad: null,
        axisCount: null,
        turnType: null,
        totalMass: null,
        approvedLoadCoefficient: null,
        towMax: null,
        saddleMax: null,
        cabPeopleCount: null,
        mannedCount: null,
        speedMax: null,
        productionDatetime: null,
        certificateRemark: null,
        vehicleLicensePictureId: null,
        certificatePictureId: null,
        vehicleSrcLicensePicture1Id: null,
        vehicleSrcLicensePicture2Id: null,
        vehicleBodyPictureId: null,
        test: false,
        vehicleUse: null,
        totalPrice: null,
        driverGearCount: null,
        mileage: null,
        canFiling: null,
        canTransfer: null
      }
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_AddObj'
    ]),
    searchVehicleType (input) {
      this.searchVehicleTypeLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleTypeList = []
        this.searchVehicleTypeLoading = false
      } else {
        store.dispatch('VehicleTypeServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleTypeList = store.getters.get_VehicleType_SearchByNameResult ? store.getters.get_VehicleType_SearchByNameResult : []
          this.searchVehicleTypeLoading = false
        }).catch(err => {
          this.searchVehicleTypeLoading = false
        })
      }
    },
    searchVehicleBrand (input) {
      this.searchVehicleBrandLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleBrandList = []
        this.searchVehicleBrandLoading = false
      } else {
        store.dispatch('VehicleBrandServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleBrandList = store.getters.get_VehicleBrand_SearchByNameResult ? store.getters.get_VehicleBrand_SearchByNameResult : []
          this.searchVehicleBrandLoading = false
        }).catch(err => {
          this.searchVehicleBrandLoading = false
        })
      }
    },
    searchEngineBrand (input) {
      this.searchEngineBrandLoading = true
      if (!input || input.length <= 0) {
        this.searchEngineBrandList = []
        this.searchEngineBrandLoading = false
      } else {
        store.dispatch('EngineBrandServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchEngineBrandList = store.getters.get_EngineBrand_SearchByNameResult ? store.getters.get_EngineBrand_SearchByNameResult : []
          this.searchEngineBrandLoading = false
        }).catch(err => {
          this.searchEngineBrandLoading = false
        })
      }
    },
    searchVehicleOwnerInfo (input) {
      this.searchVehicleOwnerInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleOwnerInfoList = []
        this.searchVehicleOwnerInfoLoading = false
      } else {
        store.dispatch('VehicleOwnerInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleOwnerInfoList = store.getters.get_VehicleOwnerInfo_SearchByNameResult ? store.getters.get_VehicleOwnerInfo_SearchByNameResult : []
          this.searchVehicleOwnerInfoLoading = false
        }).catch(err => {
          this.searchVehicleOwnerInfoLoading = false
        })
      }
    },
    searchClientInfo (input) {
      this.searchClientInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchClientInfoList = []
        this.searchClientInfoLoading = false
      } else {
        store.dispatch('ClientInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchClientInfoList = store.getters.get_ClientInfo_SearchByNameResult ? store.getters.get_ClientInfo_SearchByNameResult : []
          this.searchClientInfoLoading = false
        }).catch(err => {
          this.searchClientInfoLoading = false
        })
      }
    },
    searchVehicleModel (input) {
      this.searchVehicleModelLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleModelList = []
        this.searchVehicleModelLoading = false
      } else {
        store.dispatch('VehicleModelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleModelList = store.getters.get_VehicleModel_SearchByNameResult ? store.getters.get_VehicleModel_SearchByNameResult : []
          this.searchVehicleModelLoading = false
        }).catch(err => {
          this.searchVehicleModelLoading = false
        })
      }
    },
    onOk () {
      this.$Modal.confirm({
        title: '添加车辆信息',
        content: '<p>是否确认添加车辆信息</p>',
        onOk: () => {
          store.dispatch('VehicleInfoServ_AddObj', { params: this.vehicleInfo }).then(() => {
            this.$Message.success('添加车辆信息成功')
            this.cleanData()
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {

      }
    },
    cleanData () {
      this.vehicleInfo.customName = null
      this.vehicleInfo.registrationNum = null
      this.vehicleInfo.registrationColor = null
      this.vehicleInfo.vin = null
      this.vehicleInfo.bodyColor = null
      this.vehicleInfo.vehicleType.name = null
      this.vehicleInfo.vehicleBrand.name = null
      this.vehicleInfo.engineBrand.name = null
      this.vehicleInfo.engineNum = null
      this.vehicleInfo.vehicleLicenseNum = null
      this.vehicleInfo.unladenMass = null
      this.vehicleInfo.approvedLoad = null
      this.vehicleInfo.vehicleOwnerInfoId = null
      this.vehicleInfo.clientInfoId = null
      this.vehicleInfo.servicePassword = null
      this.vehicleInfo.vehicleLicenseDistributeDatetime = null
      this.vehicleInfo.vehicleLicenseReigsterDatetime = null
      this.vehicleInfo.businessUserId = null/// //
      this.vehicleInfo.remark = null
      this.vehicleInfo.certificateNum = null
      this.vehicleInfo.certificateDistributeDatetime = null
      this.vehicleInfo.vehicleModel.name = null
      this.vehicleInfo.chassisModel = null
      this.vehicleInfo.chassisId = null
      this.vehicleInfo.chassisCertificateNum = null
      this.vehicleInfo.engineModel = null
      this.vehicleInfo.energyType = null
      this.vehicleInfo.displacement = null
      this.vehicleInfo.power = null
      this.vehicleInfo.energyUsage = null
      this.vehicleInfo.emissionStandard = null
      this.vehicleInfo.manufacturer = null
      this.vehicleInfo.outlineSizeLong = null
      this.vehicleInfo.outlineSizeWidth = null
      this.vehicleInfo.outlineSizeHeight = null
      this.vehicleInfo.boxSizeLong = null
      this.vehicleInfo.boxSizeWidth = null
      this.vehicleInfo.boxSizeHeight = null
      this.vehicleInfo.springPieceCount = null
      this.vehicleInfo.tyreCount = null
      this.vehicleInfo.tyreSpec = null
      this.vehicleInfo.wheelSpanFront = null
      this.vehicleInfo.wheelSpanBack = null
      this.vehicleInfo.wheelBase = null
      this.vehicleInfo.driveWheelCount = null
      this.vehicleInfo.wheelCount = null
      this.vehicleInfo.axisLoad = null
      this.vehicleInfo.axisCount = null
      this.vehicleInfo.turnType = null
      this.vehicleInfo.totalMass = null
      this.vehicleInfo.approvedLoadCoefficient = null
      this.vehicleInfo.towMax = null
      this.vehicleInfo.saddleMax = null
      this.vehicleInfo.cabPeopleCount = null
      this.vehicleInfo.mannedCount = null
      this.vehicleInfo.speedMax = null
      this.vehicleInfo.productionDatetime = null
      this.vehicleInfo.certificateRemark = null
      this.vehicleInfo.vehicleLicensePictureId = null
      this.vehicleInfo.certificatePictureId = null
      this.vehicleInfo.vehicleSrcLicensePicture1Id = null
      this.vehicleInfo.vehicleSrcLicensePicture2Id = null
      this.vehicleInfo.vehicleBodyPictureId = null
      this.vehicleInfo.test = false
      this.vehicleInfo.vehicleUse = null
      this.vehicleInfo.totalPrice = null
      this.vehicleInfo.driverGearCount = null
      this.vehicleInfo.mileage = null
      this.vehicleInfo.canFiling = null
      this.vehicleInfo.canTransfer = null
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        name: this.nameRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<style scoped>

  .field {
    margin-left: 5px;
    width: 70%;
  }
</style>
